export const scenarioBank = [
  {
    "id": "scenario_01",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you prefer synchronous morning stand-ups or asynchronous written updates?",
    "optionsArray": [
      "Synchronous morning stand-ups",
      "Asynchronous written updates"
    ]
  },
  {
    "id": "scenario_02",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When planning a new project, do you prefer to create a detailed outline first, or dive straight into a rough draft?",
    "optionsArray": [
      "Create a detailed outline",
      "Dive straight into a rough draft"
    ]
  },
  {
    "id": "scenario_03",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When receiving constructive criticism from a manager, do you prefer it delivered immediately in real-time or scheduled during a formal 1-on-1?",
    "optionsArray": [
      "Immediate real-time feedback",
      "Scheduled formal 1-on-1 feedback"
    ]
  },
  {
    "id": "scenario_04",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you focus better in an open-plan collaborative workspace or a quiet, private work pod?",
    "optionsArray": [
      "Open-plan collaborative space",
      "Quiet, private work pod"
    ]
  },
  {
    "id": "scenario_05",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When a client is visibly angry on a phone call, is your immediate instinct to actively listen and let them vent, or immediately jump in with a proposed solution?",
    "optionsArray": [
      "Actively listen and let them vent",
      "Immediately jump in with a solution"
    ]
  },
  {
    "id": "scenario_06",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you prefer to tackle your most difficult, focus-intensive tasks early in the morning or later in the afternoon?",
    "optionsArray": [
      "Early in the morning",
      "Later in the afternoon"
    ]
  },
  {
    "id": "scenario_07",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When brainstorming solutions, do you prefer a structured group whiteboarding session or independent thinking time before sharing ideas?",
    "optionsArray": [
      "Structured group whiteboarding",
      "Independent thinking time first"
    ]
  },
  {
    "id": "scenario_08",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you find networking events with large groups of strangers energizing or draining?",
    "optionsArray": [
      "Energizing",
      "Draining"
    ]
  },
  {
    "id": "scenario_09",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When a minor conflict arises with a peer, do you address it instantly to clear the air, or wait 24 hours for emotions to cool down?",
    "optionsArray": [
      "Address it instantly",
      "Wait 24 hours to cool down"
    ]
  },
  {
    "id": "scenario_10",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When starting a new role, do you prefer a heavily structured, week-long onboarding program, or being thrown immediately into real tasks with a mentor?",
    "optionsArray": [
      "Structured week-long onboarding",
      "Immediate real tasks with a mentor"
    ]
  },
  {
    "id": "scenario_11",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When starting your workday, do you prefer tackling the hardest task first or checking off several quick wins?",
    "optionsArray": [
      "Hardest task first",
      "Quick wins first"
    ]
  },
  {
    "id": "scenario_12",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you work best under strict, non-negotiable deadlines or flexible, fluid timelines?",
    "optionsArray": [
      "Strict deadlines",
      "Flexible timelines"
    ]
  },
  {
    "id": "scenario_13",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you prefer to plan your weekly schedule down to the hour or leave wide blocks of unassigned time?",
    "optionsArray": [
      "Planned to the hour",
      "Wide blocks of unassigned time"
    ]
  },
  {
    "id": "scenario_14",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When a meeting ends five minutes early, do you use the time to chat with colleagues or immediately jump back into your work?",
    "optionsArray": [
      "Chat with colleagues",
      "Jump back into work"
    ]
  },
  {
    "id": "scenario_15",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you prefer to fully complete one project before starting another, or juggle multiple projects simultaneously?",
    "optionsArray": [
      "Complete one project first",
      "Juggle multiple simultaneously"
    ]
  },
  {
    "id": "scenario_16",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When reviewing a document, are you more focused on big-picture concepts or spotting minor spelling and grammar errors?",
    "optionsArray": [
      "Big-picture concepts",
      "Spotting minor errors"
    ]
  },
  {
    "id": "scenario_17",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "If a project is running slightly behind, do you prefer to stay late to finish it or wake up early the next morning?",
    "optionsArray": [
      "Stay late",
      "Wake up early"
    ]
  },
  {
    "id": "scenario_18",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Do you prefer daily check-ins with your manager or a single, longer weekly review?",
    "optionsArray": [
      "Daily check-ins",
      "Single weekly review"
    ]
  },
  {
    "id": "scenario_19",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "When you make a minor mistake, do you prefer to fix it quietly yourself or immediately notify your team?",
    "optionsArray": [
      "Fix it quietly",
      "Immediately notify team"
    ]
  },
  {
    "id": "scenario_20",
    "category": "Rapid-Fire Intuition Gates",
    "interactionType": "radio",
    "promptText": "Would you rather have a predictable routine every day or a constant variety of unexpected tasks?",
    "optionsArray": [
      "Predictable routine",
      "Constant variety"
    ]
  },
  {
    "id": "scenario_21",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You are managing a crucial project with a strict Friday deadline. Your most productive team member, who completes the majority of the technical work, is behaving toxically. They frequently mock junior staff and refuse to document their processes, creating a hostile environment. Today, they berated a junior employee to the point of tears. If you reprimand them now, they may walk off the job, guaranteeing you miss the Friday deadline.",
    "optionsArray": [
      "Ignore the toxic behavior until Friday evening to guarantee the project is delivered, then address it on Monday.",
      "Immediately pull the top performer aside, issue a formal warning, and accept the risk that they might walk out and ruin the project.",
      "Privately comfort the junior employee and ask them to endure the situation until the deadline passes, promising to fix it later.",
      "Reassign the top performer to work in absolute isolation for the rest of the week to physically separate them from the team."
    ]
  },
  {
    "id": "scenario_22",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Your direct manager asks you to tell a key client that a delayed shipment was caused by 'severe weather disruptions,' which is covered under the contract's force majeure clause. However, you know the actual cause of the delay was an internal manufacturing error by your team. Lying protects the company from a massive financial penalty, but telling the truth exposes you to your manager's anger.",
    "optionsArray": [
      "Refuse your manager's request and inform the client of the truth, prioritizing your personal integrity over the company's finances.",
      "Tell the client the weather excuse as requested by your manager, prioritizing team loyalty and chain-of-command.",
      "Ask your manager to communicate the weather excuse to the client themselves, removing yourself from the direct lie.",
      "Inform the client there was a 'logistical disruption' without specifying weather or manufacturing, leaving the cause ambiguous."
    ]
  },
  {
    "id": "scenario_23",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You are presenting a major project to the CEO. The project was highly successful, but the core strategy was entirely developed by a junior analyst on your team who is not in the room. During the presentation, the CEO heavily praises you for your 'brilliant strategic vision' and offers you a spot on an elite leadership committee based on this work.",
    "optionsArray": [
      "Accept the praise and the committee spot, reasoning that as the manager, you are ultimately responsible for the team's output.",
      "Immediately correct the CEO in the meeting, giving full credit to the junior analyst, even if it makes you look less strategic.",
      "Accept the praise in the room, but quietly advocate for a bonus for the junior analyst later without telling the CEO they created the strategy.",
      "Tell the CEO it was a 'team effort' to share credit vaguely, without specifically naming the junior analyst."
    ]
  },
  {
    "id": "scenario_24",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Your team has spent six months developing a new reporting feature for clients. One week before launch, you discover a minor data bug. It only affects 2% of users, and the data is only slightly delayed, not corrupted. Fixing the bug will delay the launch by a month, missing a major marketing window and angering the executives. Releasing it hits the deadline but risks client trust.",
    "optionsArray": [
      "Delay the launch for a month to fix the bug, ensuring the product is perfect but facing severe executive backlash.",
      "Launch on time with the known bug, hoping the 2% of affected users don't notice, and patch it quietly later.",
      "Launch on time, but preemptively notify all clients that a minor data delay issue exists and a patch is coming.",
      "Ask your team to work entirely through the weekend, sleeping in the office, to try and fix it before the deadline."
    ]
  },
  {
    "id": "scenario_25",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You accidentally overhear an executive meeting and learn that a massive round of layoffs is happening next week. Your closest friend at the company, who just bought a new house, is on the termination list. An hour later, they excitedly ask you if you think they will get a good annual bonus this year.",
    "optionsArray": [
      "Tell them the truth about the impending layoffs so they can start preparing financially immediately.",
      "Lie and say you think they will get a great bonus, preserving your own job security by keeping the confidential secret.",
      "Tell them you don't know about bonuses, but cryptically advise them to hold off on any major house renovations for a while.",
      "Immediately go to HR, confess what you overheard, and ask them how you should handle the conversation with your friend."
    ]
  },
  {
    "id": "scenario_26",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "The company has implemented a new 'Return to Office' policy requiring five days a week in person. Your team has been highly productive fully remote, and several team members threaten to quit over the new rule. You personally disagree with the policy, but as their manager, you are instructed by leadership to enforce it strictly and enthusiastically.",
    "optionsArray": [
      "Enforce the policy strictly and pretend to be enthusiastic about it, aligning completely with upper management.",
      "Enforce the policy, but openly admit to your team that you disagree with it, fostering solidarity but undermining leadership.",
      "Secretly allow your team to work from home two days a week, lying to upper management about their attendance.",
      "Compile data proving the team's remote productivity and formally present it to executives, petitioning for an exemption."
    ]
  },
  {
    "id": "scenario_27",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "A major client project is suffering from severe 'scope creep.' The client keeps demanding extra features not in the contract. Your team is exhausted and working weekends. However, the client is a close personal friend of your company's CEO, and pushing back might get you fired.",
    "optionsArray": [
      "Enforce the contract strictly, telling the client no more free work will be done, risking the CEO's anger.",
      "Schedule a meeting with the CEO to explain the situation, asking them to manage their friend's expectations.",
      "Continue absorbing the extra work to keep the client happy, promising your team a long vacation once it's over.",
      "Slow down the delivery of the extra features drastically, hoping the client gets frustrated and stops asking for more."
    ]
  },
  {
    "id": "scenario_28",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You accidentally discover that a well-liked peer has been expensing personal dinners as client meetings. If you report them, they will likely be fired, damaging team morale. If you stay silent, you become complicit in company theft. How do you handle this?",
    "optionsArray": [
      "Report the peer immediately to HR and let the chips fall where they may.",
      "Confront the peer privately, demanding they stop and reimburse the company.",
      "Keep quiet, assuming it is management's responsibility to catch expense fraud.",
      "Drop an anonymous tip to the finance department so you aren't directly involved."
    ]
  },
  {
    "id": "scenario_29",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "It is 4:45 PM on a Friday and you are about to leave for a family weekend trip. A client emails furious about a typo in a live campaign. Fixing it takes two hours and you are the only one who knows the system. What do you do?",
    "optionsArray": [
      "Cancel your Friday evening plans and fix the error yourself to save the relationship.",
      "Email the client an apology and promise to fix it first thing Monday morning.",
      "Attempt a quick, untested 5-minute fix that might break the campaign entirely.",
      "Call a coworker who is off-shift and beg them to log in and figure it out."
    ]
  },
  {
    "id": "scenario_30",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Your team is severely burned out, but the CEO announces a surprise, high-profile sprint project and asks for volunteers. Volunteering guarantees bonuses for your team, but pushing them harder will likely cause your best employee to quit from exhaustion.",
    "optionsArray": [
      "Volunteer the team to secure the bonuses, accepting the loss of your best employee.",
      "Politely decline the project, protecting your team's mental health but looking uncommitted.",
      "Ask the team to vote anonymously, shifting the burden of the decision onto them.",
      "Volunteer to do the sprint project entirely by yourself, working 80-hour weeks."
    ]
  },
  {
    "id": "scenario_31",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You manage a hybrid team. You notice that employees coming into the physical office are getting promoted faster by upper management than fully remote employees, despite having identical output metrics. Confronting management could stall your own career.",
    "optionsArray": [
      "Document the data and formally present it to HR as a serious equity issue.",
      "Quietly advise your remote workers to come into the office more often for visibility.",
      "Implement a strict remote-only policy for your own team to level the playing field.",
      "Focus only on aggressively highlighting remote workers' successes in leadership meetings."
    ]
  },
  {
    "id": "scenario_32",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Your direct supervisor has started assigning you personal errands, such as booking their family vacations. These tasks only take an hour a week, but are outside your job description. However, this supervisor controls your upcoming annual bonus.",
    "optionsArray": [
      "Comply cheerfully to stay in their good graces and secure your bonus.",
      "Politely refuse the next request, stating your focus must remain on professional tasks.",
      "Document the requests and anonymously report the behavior to HR.",
      "Start deliberately doing the personal errands poorly so they stop asking you."
    ]
  },
  {
    "id": "scenario_33",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You accidentally CC'd a client on an internal email where a colleague used unprofessional language to describe the client's demands. The client hasn't replied yet. Your colleague is unaware and currently leading a major presentation for another account.",
    "optionsArray": [
      "Call the client immediately to apologize and explain before they read the email.",
      "Use the email system's recall function and pray the client hasn't opened it yet.",
      "Pull your colleague out of their presentation immediately to address the crisis.",
      "Notify your department head right away and let them decide how to manage the fallout."
    ]
  },
  {
    "id": "scenario_34",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Your company implemented a new software tool for tracking all employee hours down to the minute. Your team finds it invasive and it actively slows down actual work. As a middle manager, you are required to enforce this unpopular tool.",
    "optionsArray": [
      "Strictly enforce the tool as mandated, prioritizing company policy over team complaints.",
      "Tell the team they only need to estimate their hours at week's end to save time.",
      "Enforce the tool but gather concrete data on wasted time to present to leadership.",
      "Refuse to enforce the tool for your team, absorbing the disciplinary risk yourself."
    ]
  },
  {
    "id": "scenario_35",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "You discover that a popular company perk, which allows flexible Friday hours, technically violates a minor labor regulation regarding time-tracking. Reporting it will force HR to cancel the perk, making you deeply unpopular with the entire office.",
    "optionsArray": [
      "Report the violation to HR immediately and face the intense resentment of your peers.",
      "Keep quiet and let the policy continue since it benefits everyone and the risk is low.",
      "Try to anonymously tip off HR so the policy is fixed without you taking the blame.",
      "Convince your manager to slowly phase out the perk over six months with a fabricated excuse."
    ]
  },
  {
    "id": "scenario_36",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "A recent M&A integration has hit a critical bottleneck: the acquired company's legacy CRM is hardcoded with European data privacy structures that violently clash with our US-based aggressive lead-scoring algorithm. Legal states that migrating them to our system risks a €20M GDPR fine. Sales leadership claims operating dual systems will cause a 25% drop in Q1 revenue due to cross-selling blind spots. The Board expects synergy cost-savings by Friday.",
    "optionsArray": [
      "Ring-fence the European CRM, assigning a dedicated ops team to manually sync anonymized aggregate data weekly.",
      "Force the migration to the US system but throttle the lead-scoring algorithm to only process explicit opt-in data globally.",
      "Halt integration, swallow the missed Q1 synergy targets, and rebuild the core CRM to natively support federated data compliance."
    ]
  },
  {
    "id": "scenario_37",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "Our predictive policing SaaS suite is being used by a major metro department. The system accurately predicted a massive spike in organized retail theft, but the designated hotspots are entirely in marginalized neighborhoods. City council is demanding we alter the algorithm to distribute patrols more 'equitably' across affluent areas, even though our data science team insists this will allow the actual theft rings to operate with impunity.",
    "optionsArray": [
      "Refuse to alter the algorithm, stand by the pure statistical data, and risk losing the city contract to a more compliant vendor.",
      "Alter the algorithm to artificially distribute patrols into affluent areas, pacifying the city council but degrading the software's efficacy.",
      "Obfuscate the geographic output by replacing 'hotspot maps' with 'individual suspect profiles', shifting the focus from neighborhoods to people.",
      "Open-source the prediction model specifically for this city, forcing the council to argue with the raw math in the public square."
    ]
  },
  {
    "id": "scenario_38",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "A cascading flash crash initiated by our proprietary HFT (High-Frequency Trading) algorithm is currently wiping billions off the global equities market. Unplugging our Direct Market Access (DMA) will instantly stop the bleeding, but will trigger a hard-coded fail-safe in the clearinghouse that seizes our entire $10B operational treasury. Letting the algorithm fight it out might stabilize the market in 10 minutes, or crash the global economy.",
    "optionsArray": [
      "Unplug the DMA instantly, accepting the seizure of the $10B treasury to save the global equities market.",
      "Let the algorithm run its course for 10 minutes, risking a historic global market collapse in the hope of self-correction.",
      "Initiate a targeted DDoS attack against the exchange's matching engine, forcing a market-wide trading halt without triggering our fail-safe.",
      "Inject a massive influx of dummy buy-orders to confuse our own algorithm, intentionally triggering a localized logic loop to stall it."
    ]
  },
  {
    "id": "scenario_39",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "A sophisticated ransomware gang has exfiltrated 2 terabytes of raw neural data from our consumer Brain-Computer Interface (BCI) headsets. This data contains intimate cognitive patterns that could theoretically be used to decode users' political leanings and sexual orientations. The ransom is $12M. Law enforcement strictly advises against paying, but our Terms of Service never explicitly covered 'neural data extraction' liability.",
    "optionsArray": [
      "Refuse to pay the ransom, comply with law enforcement, and offer users free credit monitoring (which is useless for neural data).",
      "Pay the $12M ransom via an untraceable privacy coin and trust the hackers to delete the dataset as promised.",
      "Publicly release a poisoned, synthetic version of the neural dataset to pollute the hackers' leverage and render the real data unverifiable.",
      "Pivot aggressively to a hardware recall, claiming the headsets have a thermal defect to distract from the data breach."
    ]
  },
  {
    "id": "scenario_40",
    "category": "High-Cognitive Load Scenarios",
    "interactionType": "radio",
    "promptText": "During Phase 3 clinical trials of our proprietary CRISPR gene therapy, 5 patients in a localized testing cluster developed severe autoimmune reactions. The data suggests the reaction is strictly triggered by a rare environmental pathogen unique to that specific geographic region. Halting the global trial will tank our IPO and delay life-saving treatment for millions. Ignoring it risks those 5 patients dying.",
    "optionsArray": [
      "Halt the global Phase 3 trial immediately to investigate the autoimmune reactions, delaying the IPO indefinitely.",
      "Exclude the geographic cluster from the dataset, labeling them 'anomalous environmental outliers', and proceed with the IPO.",
      "Continue the global trial but secretly administer extreme immunosuppressants to the 5 affected patients to stabilize their condition.",
      "Pivot the PR narrative to highlight the therapy's success in 99% of cases, establishing an aggressive victim compensation fund."
    ]
  },
  {
    "id": "scenario_41",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "drag-drop-rank",
    "promptText": "Rank the following four tasks in order of execution priority when you arrive at the office on Monday morning and find the network is temporarily offline.",
    "optionsArray": [
      "Organize physical files and clean your desk area",
      "Draft emails offline to be sent automatically when the network returns",
      "Call a key client on your cell phone to provide a scheduled update",
      "Walk to a colleague's desk to brainstorm ideas for next month's campaign"
    ]
  },
  {
    "id": "scenario_42",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "slider",
    "promptText": "You have a $10,000 end-of-year surplus budget. Allocate the funds between upgrading your team's outdated computer monitors (Left) or bringing in a high-profile guest speaker for a day of professional development (Right).",
    "optionsArray": [
      "Hardware Upgrades",
      "Professional Development"
    ]
  },
  {
    "id": "scenario_43",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "matrix",
    "promptText": "Distribute your 40-hour work week across the following four categories by allocating percentage weights. (Total must equal 100%)",
    "optionsArray": [
      "Deep, uninterrupted independent work",
      "Collaborative team meetings and brainstorming",
      "Administrative tasks (emails, expense reports, scheduling)",
      "Mentoring junior staff and professional development"
    ]
  },
  {
    "id": "scenario_44",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "matrix",
    "promptText": "Your department is moving to a smaller physical office. Allocate the limited square footage among the following team functions.",
    "optionsArray": [
      "Large, glass-walled conference rooms for client pitches",
      "Individual, sound-proofed phone booths for sales calls",
      "An open-plan desk area to maximize total headcount",
      "A comfortable lounge area to encourage informal collaboration"
    ]
  },
  {
    "id": "scenario_45",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "drag-drop-rank",
    "promptText": "Rank these four project risks in order from most critical to address immediately to least critical.",
    "optionsArray": [
      "Key team member might quit",
      "Project might go 10% over budget",
      "Delivery date might slip by two days",
      "Competitor might launch a similar feature first"
    ]
  },
  {
    "id": "scenario_46",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "matrix",
    "promptText": "Evaluate these four incoming requests by placing them in the correct quadrant based on Urgency and Importance.",
    "optionsArray": [
      "Boss needs a status update in 10 minutes",
      "A loyal client asks a general product question",
      "The company CRM requires a password reset",
      "A junior colleague asks for career mentorship"
    ]
  },
  {
    "id": "scenario_47",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "slider",
    "promptText": "Distribute a $5,000 performance bonus pool among four team members based on their recent contributions.",
    "optionsArray": [
      "The steady reliable veteran",
      "The brilliant but erratic innovator",
      "The hardworking intern who made a major error",
      "The new hire who is learning quickly"
    ]
  },
  {
    "id": "scenario_48",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "drag-drop-rank",
    "promptText": "Rank these four candidate profiles from most important to hire to least important when filling an entry-level customer service role.",
    "optionsArray": [
      "Candidate A: Highly empathetic but easily stressed",
      "Candidate B: Technically proficient but bluntly honest",
      "Candidate C: Enthusiastic and eager but lacks experience",
      "Candidate D: Calm under pressure but slow to respond"
    ]
  },
  {
    "id": "scenario_49",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "drag-drop-rank",
    "promptText": "A sophisticated zero-day ransomware worm is laterally traversing the enterprise network. We have exactly 60 seconds before it reaches the core databases. Rank the following infrastructure sectors in the order they should be hard-severed from the network.",
    "optionsArray": [
      "Sector 1: The live payment processing gateway handling $5M per minute.",
      "Sector 2: The encrypted cold-storage backups containing all historical customer PII.",
      "Sector 3: The automated warehouse logistics API currently directing 500 robotics units.",
      "Sector 4: The executive communication array hosting an ongoing M&A negotiation."
    ]
  },
  {
    "id": "scenario_50",
    "category": "Spatial / Kinematic Drills",
    "interactionType": "drag-drop-rank",
    "promptText": "Due to an unprecedented macro-economic shock, we must immediately slash $50M from our advanced R&D budget to remain solvent. Rank the following projects in order of which should be defunded and liquidated first.",
    "optionsArray": [
      "Project A: The near-complete solid-state battery architecture (High CapEx, 3-year ROI).",
      "Project B: The algorithmic algorithmic supply chain optimization AI (Low CapEx, instant operational savings).",
      "Project C: The neuro-haptic VR interface beta (Massive sunk cost, volatile consumer market).",
      "Project D: The defensive cybersecurity quantum-encryption shield (Zero immediate revenue, mitigates existential risk)."
    ]
  }
];